export const cutContent = (str, length = 140) =>
  str.substring(0, Math.min(str.length, length));

export const allCaps = (str = "") => str.toUpperCase();
